import { Dispatch } from 'redux';
import fetchApi from '../services/api';
import * as types from './actionTypes';
import track from '../lib/track';
import {
  emitNotificationEvent,
  forceLoginHelper,
  STANDARD_ERROR_MESSAGE,
} from './auth';

export const BLOCKED_FETCH_LIMIT = 18;

/**
 * Fetch a user's blocked listings.
 * @param {string} token - A user's authentication token
 */

export function fetchBlockedListings(
  token: string,
  offset: number = 0,
  limit: number = BLOCKED_FETCH_LIMIT,
  reset: boolean = false,
) {
  return async (dispatch: Dispatch<any>) => {
    dispatch({
      type: types.ClearMessages,
    });
    if (reset) {
      dispatch({
        type: types.ClearBlockedListings,
      });
    }
    try {
      const response = await fetchApi(
        `/blocked?offset=${offset}&limit=${limit}`,
        {},
        'get',
        {},
        token,
      );
      const json = await response.json();
      if (response.ok) {
        return dispatch({
          blockedListings: json.results,
          type: types.BlockedFetchSuccess,
        });
      } else {
        return dispatch(
          forceLoginHelper(json, () => {
            dispatch({
              messages: [json],
              type: types.BlockedFetchFailure,
            });
          }),
        );
      }
    } catch (error) {
      dispatch({
        error,
        type: types.GenericError,
      });
    }
  };
}

// Block a listing. This will make it so a user will no longer see this listing.
export function blockListing(
  id: number,
  token: string,
  skipNotificationEvent: boolean = false,
) {
  return async (dispatch: any) => {
    dispatch({
      type: types.ClearMessages,
    });
    try {
      const response = await fetchApi(`/blocked/${id}`, {}, 'post', {}, token);
      const json = await response.json();
      if (response.ok) {
        track.blockedListing(id);
        if (!skipNotificationEvent) {
          emitNotificationEvent('success', json.msg);
        }
        return dispatch({
          listing: json.listing,
          messages: [json],
          type: types.BlockListingSuccess,
        });
      } else {
        return dispatch(
          forceLoginHelper(json, () => {
            if (!skipNotificationEvent) {
              emitNotificationEvent('error', json.msg);
            }
            dispatch({
              messages: [json],
              type: types.BlockListingFailure,
            });
          }),
        );
      }
    } catch (error) {
      emitNotificationEvent('error', STANDARD_ERROR_MESSAGE);
      dispatch({
        error,
        type: types.GenericError,
      });
    }
  };
}

// Make a listing visible again for a user
export function removeBlockedListing(id: string, token: string) {
  return async (dispatch: any) => {
    try {
      const response = await fetchApi(
        `/blocked/${id}`,
        {},
        'delete',
        {},
        token,
      );
      const json = await response.json();
      if (response.ok) {
        dispatch({
          deleteBlockedListingId: json.deletedListing,
          type: types.DeleteBlockedSuccess,
        });
      } else {
        dispatch({
          type: types.DeleteBlockedFailure,
        });
      }
    } catch (error) {
      dispatch({
        error,
        type: types.GenericError,
      });
    }
  };
}
